import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { webPagesTitle } from "routers/webPagesTitle";

import {
  //
  Home,
  AboutUs,
  ContactUs,
  Profile,
  CompanyProfile,

  //
  Organization,
  EmployeePermissions,

  //
  Attribute,
  Attributes,

  //
  Company,
  Companies,

  //
  Wholesaler,
  Wholesalers,

  //
  Category,
  Categories,

  //
  Customer,
  Customers,

  //
  Product,
  Products,

  //
  Factor,
  Factors,
  addNewFactorItems,

  //
  Reminder,
  Reminders,

  //
  Note,
  Notes,
  CustomerNotes,
  EditCustomerNote,

  //
  Corp,
  Corps,

  //
  CEO,
  CEOs,

  //
  User,
  Users,

  //
  TypeOfMeeting,
  ApkVersion,
  Report,
  Reports,
  AddCorp,
  CustomerReport,

  //
  Countries,

  //
} from "screens";
import { colors } from "assets/constants";

const Stack = createNativeStackNavigator<Routes>();

export default function Lead() {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.bg.screen },
      }}
    >
      <Stack.Screen
        options={{ title: webPagesTitle.home }}
        name={"home"}
        component={Home}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.profile }}
        name={"profile"}
        component={Profile}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.company_profile }}
        name={"company_profile"}
        component={CompanyProfile}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.contact_us }}
        name={"contact_us"}
        component={ContactUs}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.about_us }}
        name={"about_us"}
        component={AboutUs}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.organization }}
        name={"organization"}
        component={Organization}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.employee_permissions }}
        name={"employee_permissions"}
        component={EmployeePermissions}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.attributes }}
        name={"attributes"}
        component={Attributes}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.attribute }}
        name={"attribute"}
        component={Attribute}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.categories }}
        name={"categories"}
        component={Categories}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.category }}
        name={"category"}
        component={Category}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.products }}
        name={"products"}
        component={Products}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.product }}
        name={"product"}
        component={Product}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.corp }}
        name={"corp"}
        component={Corp}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.add_corp }}
        name={"add_corp"}
        component={AddCorp}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.corps }}
        name={"corps"}
        component={Corps}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.CEO }}
        name={"CEO"}
        component={CEO}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.CEOs }}
        name={"CEOs"}
        component={CEOs}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.report }}
        name={"report"}
        component={Report}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.report }}
        name={"customer_report"}
        component={CustomerReport}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.reports }}
        name={"reports"}
        component={Reports}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.customers }}
        name={"customers"}
        component={Customers}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.customer }}
        name={"customer"}
        component={Customer}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.factors }}
        name={"factors"}
        component={Factors}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.factor }}
        name={"factor"}
        component={Factor}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.add_new_factor_items }}
        name={"add_new_factor_items"}
        component={addNewFactorItems}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.notes }}
        name={"customer_notes"}
        component={CustomerNotes}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.notes }}
        name={"notes"}
        component={Notes}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.note }}
        name={"note"}
        component={Note}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.note }}
        name={"edit_customer_note"}
        component={EditCustomerNote}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.user }}
        name={"user"}
        component={User}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.users }}
        name={"users"}
        component={Users}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.companies }}
        name={"companies"}
        component={Companies}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.company }}
        name={"company"}
        component={Company}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.type_of_meeting }}
        name={"type_of_meeting"}
        component={TypeOfMeeting}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.apk_version }}
        name={"apk_version"}
        component={ApkVersion}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.wholesalers }}
        name={"wholesalers"}
        component={Wholesalers}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.wholesaler }}
        name={"wholesaler"}
        component={Wholesaler}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.reminder }}
        name={"reminder"}
        component={Reminder}
      />
      <Stack.Screen
        options={{ title: webPagesTitle.reminders }}
        name={"reminders"}
        component={Reminders}
      />

      <Stack.Screen
        options={{ title: webPagesTitle.countries }}
        name={"countries"}
        component={Countries}
      />
    </Stack.Navigator>
  );
}
